import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { FiWrapperTableCellBase } from '@fi-shared/fi-wrapper-table/cells/fi-wrapper-table-cell-base';

@Component({
    selector: 'fi-wrapper-table-span-cell',
    template: ``,
    styleUrls: ['./fi-wrapper-table-span-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-wrapper-table-span-cell' },
    standalone: false,
})
export class FiWrapperTableSpanCellComponent extends FiWrapperTableCellBase<string | number> {
    @HostBinding('textContent')
    get textContent() {
        return this.value;
    }

    @HostBinding('attr.title')
    get title() {
        return this.value;
    }
}
